// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__Ibxiz","label":"Completed_label__1m7_P"};